export default "__VITE_ASSET__Ba9GLRN2__"